import {Action, Module, Mutation, VuexModule} from 'vuex-module-decorators';
import {Inject} from 'inversify-props';

import {Stats} from '@/model/system/Stats';

import {ISystemStatsService} from '@/services/system/IStats.service';

@Module({name: 'SystemStatsStore', namespaced: true})
export default class SystemStatsStore extends VuexModule {
  private stats: Stats | null = null;

  @Inject(Symbol.for('ISystemStatsService'))
  private statsService!: ISystemStatsService;

  @Action({commit: 'setStats', rawError: true})
  public async fetchStats() {
    return await this.statsService.getInfo();
  }

  @Mutation
  public setStats(stats: Stats) {
    this.stats = stats;
  }

  get Stats() {
    return this.stats;
  }
}
